import { Flow } from "./types";
import { createRequestType } from "../../../helpers/requestType";

export const fillBotFlowsActionType = createRequestType('FILL_BOT_FLOWS');
interface FillBotFlowsRequestAction {
  type: typeof fillBotFlowsActionType.request;
  payload: any;
}

interface FillBotFlowsSuccessAction {
  type: typeof fillBotFlowsActionType.success;
  payload: Flow[];
}

interface FillBotFlowsFailureAction {
  type: typeof fillBotFlowsActionType.failure;
  payload: any;
}

export const saveFlowActionType = createRequestType('SAVE_FLOW');
interface SaveFlowRequestAction {
  type: typeof fillBotFlowsActionType.request;
  payload: Flow;
}

interface SaveFlowSuccessAction {
  type: typeof fillBotFlowsActionType.success;
  payload: Flow;
}

interface SaveFlowFailureAction {
  type: typeof fillBotFlowsActionType.failure;
  payload: any;
}


export type FlowActionTypes = FillBotFlowsRequestAction 
| FillBotFlowsSuccessAction 
| FillBotFlowsFailureAction 
| SaveFlowRequestAction
| SaveFlowSuccessAction
| SaveFlowFailureAction